module.exports = __webpack_public_path__ + "static/media/piled-of-stones-near-lake-2825368.b0b7c80d.jpg";